import React from 'react'
import PlusVipStandardZero from '../components/dashboard/PlusVipStandardZero'

const PlusVipStandardZeroPage = () => <PlusVipStandardZero />

export default PlusVipStandardZeroPage
